<template>
  <div id="app" class="h-screen overflow-hidden" style="overflow: hidden !important; max-width: 100vw; max-height: 100vh;">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
